module.exports = __webpack_public_path__ + "static/media/Avenir-Heavy.94a57b63.woff";